import { Notify } from '../models/notifications';

import { createContext, useContext } from 'react';

const notifyContext = createContext<Notify>(() => {});

export const NotifyContextProvider = notifyContext.Provider;

export function useNotify(): Notify {
  return useContext(notifyContext);
}
